import React from 'react';
import { Link } from 'gatsby';

import { Section, Layout, SEO } from '..';
import { ETRSection } from './ETRSection';
import style from './LoveMessage.module.less';

import arrow from './assets/arrow.png';
import hero from './assets/hero.jpg';
import browser from './assets/browser.png';
import difficulty from './assets/difficulty.png';
import time from './assets/time.png';
import social from './assets/social.png';

export const LoveMessagePage = () => (
  <Layout transparentTop={true}>
    <SEO
      title="Puzzle Box"
      description="Hide a message behind the puzzles. Share with your spouse, love interest or a friend. All that for free!"
      image={social}
    />

    <Section className={style.hero} alternate={true} straightTop={true} style={{ backgroundImage: `url(${hero})` }}>
      <div className={style.wrapper}>
        <h1>Send a Box with a hidden message</h1>
        <p>
          Hide a message behind the puzzles.
          <br />
          Share with your spouse, love interest or a friend.
          <br />
          All that for free!
        </p>
        <Link
          className={style.learnMore}
          to="/message/create"
        >
          Create a Box
        </Link>
      </div>
    </Section>

    <Section className={style.howTo}>
      <h1 className={style.header}>How does it work?</h1>

      <div className={style.contentNarrow}>
        <div className={style.arrow}>
          <img src={arrow} alt="Arrow 1" />
          <span>1</span>
        </div>
        <h2>Prepare a special message</h2>
        <div className={style.text}>
          What's the message you want to send? Can be warm words, can be a date location reveal, can be clever joke... Go wild and prepare something neat!
        </div>
      </div>

      <div className={style.contentNarrow}>
        <div className={style.arrow}>
          <img src={arrow} alt="Arrow 2" />
          <span>2</span>
        </div>
        <h2>Share a unique link</h2>
        <div className={style.text}>
          Send an e-mail with a special, unique link.
        </div>
      </div>

      <div className={style.contentNarrow}>
        <div className={style.arrow}>
          <img src={arrow} alt="Arrow 3" />
          <span>3</span>
        </div>
        <h2>Wait for the recipient to solve the puzzles and read your message</h2>
        <div className={style.text}>
          That's it, that's all. The puzzles are simple, the device is cute, and the message is yours!
        </div>
      </div>
    </Section>

    <Section alternate={true} className={style.loveSection}>
      <div className={style.content}>
        <h1 className={style.header}>I want to test the Box!</h1>

        <p>Eager to test the Box? Click the button below to reveal a hidden message from Eleven Puzzles Team</p>

        <Link activeClassName={style.active} to="/message/box?m=jIebKHTyukRzTCiCBs4RLPJDAmR2" className={style.fancyButton}>Test the Box</Link>
      </div>
    </Section>

    <Section className={style.requirements}>
      <h1>Box requirements & details</h1>
      <div className={style.blocks}>
        <div className={style.block}>
          <img src={browser} alt="Browser" />
          <h3>Modern browser</h3>
          <p>The Box requires only a modern browser, no need to install anything!</p>
        </div>
        <div className={style.block}>
          <img src={time} alt="Time" />
          <h3>Around 3 minutes</h3>
          <p>Depending on puzzle-solving experience of your recipient this may vary</p>
        </div>
        <div className={style.block}>
          <img src={difficulty} alt="Difficulty" />
          <h3>1.5 / 5 difficulty level</h3>
          <p>It's simple and fun!</p>
        </div>
      </div>
    </Section>

    <ETRSection alternate={true} />

    <Section className={style.loveSection}>
      <div className={style.content}>
        <h1 className={style.header}>Create your own Box</h1>

        <p>Create a hidden message, save and share! You can have your Box ready in less than 5 minutes.</p>

        <Link activeClassName={style.active} to="/message/create" className={style.fancyButton}>Create a Box</Link>
      </div>
    </Section>

  </Layout>
);
